import { NotificationsTranslations } from '../en-US/notifications.translations';

export const notificationsTranslations: NotificationsTranslations = {
  title: 'Notifiche',
  pageTitle: 'Notifiche',
  pageDescription: 'Visualizza e gestisci le tue notifiche',
  settingsTitle: 'Impostazioni notifiche',
  settingsPageTitle: 'Impostazioni notifiche',
  settingsPageDescription: 'Gestisci le tue preferenze di notifica',
  settings: 'Impostazioni',
  markAsRead: 'Segna come letto',
  markAllAsRead: 'Segna tutti come letti',
  delete: 'Elimina',
  more: 'altro',
  noNotifications: 'Nessuna notifica',
  emptyDescription: 'Non hai ancora notifiche',
  errorLoading: 'Errore durante il caricamento delle notifiche',
  errorLoadingSettings: 'Errore durante il caricamento delle impostazioni delle notifiche',
  tryAgain: 'Per favore riprova più tardi',
  enableNotifications: 'Attiva notifiche',
  enablePromptMessage: 'Rimani aggiornato sulle ultime recensioni, mi piace e follower attivando le notifiche.',
  remindLater: 'Ricordamelo più tardi',
  enable: 'Attiva',
  stayUpdated: 'Rimani aggiornato',
  enableDescription: 'Attiva le notifiche per rimanere informato su nuove recensioni, mi piace e follower.',
  pushNotifications: 'Notifiche push',
  pushDescription: 'Ricevi notifiche sul tuo dispositivo',
  emailNotifications: 'Notifiche email',
  emailDescription: 'Ricevi notifiche via email',
  enableAllNotifications: 'Attiva tutte le notifiche',
  masterToggleDescription: 'Attiva/disattiva tutte le notifiche',
  notificationTypes: 'Tipi di notifiche',
  types: {
    reviewLiked: 'Recensione piaciuta',
    reviewLikedDescription: 'Ricevi una notifica quando a qualcuno piace la tua recensione',
    newPlaceReviews: 'Nuove recensioni luoghi',
    newPlaceReviewsDescription: 'Ricevi una notifica quando viene recensito un nuovo luogo',
    newFoodReviews: 'Nuove recensioni cibo',
    newFoodReviewsDescription: 'Ricevi una notifica quando viene recensito un nuovo cibo',
    newReviewCreated: 'Nuova recensione creata',
    newReviewCreatedDescription: 'Ricevi una notifica quando viene creata una nuova recensione',
    userFollowed: 'Utente seguito',
    userFollowedDescription: 'Ricevi una notifica quando un utente ti segue',
  },
}; 

export default notificationsTranslations;
